import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M101.257 31.824a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M88.555 6.44a1.5 1.5 0 0 1 0 2.12l-9.994 9.995a1.5 1.5 0 0 1-2.122-2.122l9.994-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M76.44 6.44a1.5 1.5 0 0 1 2.12 0l9.995 9.993a1.5 1.5 0 0 1-2.122 2.122L76.44 8.56a1.5 1.5 0 0 1 0-2.122"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      d="M101.257 84.988a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M44.567 92a1.5 1.5 0 0 1 1.5 1.5v14.134a1.5 1.5 0 0 1-3 0V93.5a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M36 100.567a1.5 1.5 0 0 1 1.5-1.5h14.134a1.5 1.5 0 1 1 0 3H37.5a1.5 1.5 0 0 1-1.5-1.5M20 18a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="M86.822 35.654H20.893a2.69 2.69 0 0 0-2.69 2.69v38.022a2.69 2.69 0 0 0 2.69 2.69h65.93a2.69 2.69 0 0 0 2.69-2.69V38.344a2.69 2.69 0 0 0-2.69-2.69"
    />
    <path
      fill="#0597A3"
      d="M89.513 44.678h10.608c.627 0 1.136.509 1.136 1.136v22.768c0 .627-.509 1.136-1.136 1.136H89.513z"
    />
    <path
      fill="#001A43"
      d="M57.508 46.929h-7.95a2.09 2.09 0 0 0-2.09 2.09v16.673a2.09 2.09 0 0 0 2.09 2.09h15.103a2.09 2.09 0 0 0 1.921-2.914l-7.153-16.673a2.09 2.09 0 0 0-1.921-1.266M41.725 46.929h-9.719a2.09 2.09 0 0 0-2.09 2.09v16.674a2.09 2.09 0 0 0 2.09 2.09h9.719a2.09 2.09 0 0 0 2.09-2.09V49.019a2.09 2.09 0 0 0-2.09-2.09"
    />
  </svg>
);
const SvgEnrichedIconChargeInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconChargeInverted);
export default Memo;
